// extracted by mini-css-extract-plugin
module.exports = {"search":"ContactInfoWidget_search__3W3tY"};